module.exports = __webpack_public_path__ + "static/gatsby-astronaut-bc0d3e62a65b60da7d3605c881c81fff.jpg";